<template>
  <div class="chart-answer">
    <ExerciseChart :chart="question.chart" :ticker="question.ticker" :selected-dates="selectedDates" @select-date="selectDate" />
    <div class="chart-answer__selection" aria-live="polite">
      <template v-if="kind === 'trend_line'">
        <span>Punto inicial: <strong>{{ value.starting_date || 'sin seleccionar' }}</strong></span>
        <span>Punto final: <strong>{{ value.ending_date || 'sin seleccionar' }}</strong></span>
      </template>
      <template v-else>
        <span>Vela seleccionada: <strong>{{ selectedDates[0] || 'ninguna' }}</strong></span>
      </template>
      <button v-if="selectedDates.length" type="button" @click="clear">Limpiar selección</button>
    </div>
    <label v-if="kind === 'resistance'" class="chart-answer__price">
      Nivel de resistencia
      <input inputmode="decimal" type="number" step="any" :value="value.resist_price" @input="updatePrice($event.target.value)">
    </label>
  </div>
</template>

<script>
import ExerciseChart from './ExerciseChart.vue';
import { emptyAnswer, selectChartDate } from '../models/exerciseSession';

export default {
  name: 'ChartExerciseAnswer',
  components: { ExerciseChart },
  props: {
    question: { type: Object, required: true },
    kind: { type: String, required: true },
    value: { type: Object, default: () => ({}) }
  },
  computed: {
    selectedDates() {
      return [this.value.starting_date, this.value.ending_date, this.value.rr_date, this.value.resist_date, this.value.date].filter(Boolean);
    }
  },
  methods: {
    selectDate(date) { this.$emit('input', selectChartDate(this.kind, this.value, date)); },
    clear() { this.$emit('input', emptyAnswer(this.kind)); },
    updatePrice(value) { this.$emit('input', { ...this.value, resist_price: value }); }
  }
};
</script>

<style lang="scss" scoped>
.chart-answer { display: grid; gap: 14px; }
.chart-answer__selection { display: flex; flex-wrap: wrap; align-items: center; gap: 8px 18px; padding: 13px 15px; border-radius: 13px; background: var(--modern-accent-soft); color: var(--modern-muted); font-size: 13px; }
.chart-answer__selection strong { color: var(--modern-text); }
.chart-answer__selection button { min-height: 40px; margin-left: auto; border: 0; background: transparent; color: var(--modern-accent); font: inherit; font-weight: 700; cursor: pointer; }
.chart-answer__price { display: grid; gap: 7px; color: var(--modern-text); font-size: 13px; font-weight: 700; }
.chart-answer__price input { min-height: 46px; padding: 0 12px; border: 1px solid var(--modern-border); border-radius: 11px; background: var(--modern-surface); color: var(--modern-text); font: inherit; }
</style>
